<template>
    <div class="homePage">
        <div class="container">
            <div class="header">
                <img src="../../../public/image/header.png" alt="">
                <div class="header_content">
                    <button @click="newspaperSearch()" v-if="isInlineIP">报纸检索</button>
                </div>
            </div>
            <div class="body">
                <ul class="paper_container">
                    <li v-for="paper in items" class="paper_item" @click="viewLink(paper)">
                        <div class="item_inner_box">
                            <img :src="addressPrefix + paper.digitalNewspaperLogo" :title="paper.digitalNewspaperName">
                        </div>
                    </li>
                </ul>
                <div class="pager" v-if="totalPages>1">
                    <pagination :showPagesNum="4" @change="pageChange" :pageSize.sync='pageSize' :currentPage.sync="currentPage" :totalPages.sync="totalPages" :totalItems.sync="totalItems" />
                </div>
            </div>
            <div class="footer pc">
                温州日报报业集团 版权所有 本系统支持1366*768及以上分辨率
            </div>
            <div class="footer mobile">
                温州日报报业集团 版权所有
            </div>
        </div>
    </div>
</template>                     
<script>
import pagination from '@/components/pagination.vue'
export default {
    nama: 'countyNewspaper',
    components: {
        pagination,
    },
    data() {
        return {
            pageSize: 20,
            currentPage: 1,
            totalPages: 0,
            totalItems: 0,
            items: [],
            addressPrefix: '',
            isInlineIP: ""
        };
    },
    mounted() {
        this.getPaperList();
        this.checkIPStatus();
    },
    methods: {
        /**
         * [checkIPStatus description]判断是否是内网IP，内网IP可以看到检索按钮，外网IP不可以
         * @return {[type]} [description]
         */
        checkIPStatus() {
            let self = this;
            this.post('/digitalNewspaper/web/ipConfiguration/getIpStatus', {}).then(res => {
                if (res.status == 'success') {
                    self.isInlineIP = res.ipStatus;
                }
            })
        },
        /**
         * [getPaperList 获取数字报列表]
         * @return {[type]} [description]
         */
        getPaperList() {
            let params = {
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                classify: 1,
            };
            this.post('/digitalNewspaper/web/digitalNewspaperMedia/list', params).then(data => {
                try {
                    this.items = data.msg.rows;
                    this.totalPages = data.msg.totalPages;
                    this.totalItems = data.msg.totalItems;
                    this.addressPrefix = data.addressPrefix;
                } catch (error) {
                    console.log('获取数字报列表失败', error);
                }
            })
        },
        /**
         * [pageChange 切换分页]
         * @return {[type]} [description]
         */
        pageChange() {
            this.getPaperList();
        },
        /**
         * [viewLink 打开外链]
         * @param  {[type]} paper [description]
         * @return {[type]}       [description]
         */
        viewLink(paper) {
            let router = this.$router.resolve({
                name: 'newspaperContent',
                query: {
                    mediaKey: paper.digitalNewspaperMark,
                    classify: 1,
                    tenantId: paper.tenantId,
                    id:paper.digitalNewspaperMediaId
                }
            });
            window.open(router.href);
        },
        newspaperSearch() {
            this.title = '报纸检索';
            this.$router.push({
                path: '/search'
            });
        }

    }
}
</script>
<style lang="less" scoped>
@media screen and(min-width:1201px) {
    .homePage {
        height: 100%;
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        background: url("../../../public/image/bgc.png") no-repeat center/cover;

        .container {
            width: 100%;
            height: 100%;
        }

        .header {
            width: 100%;
            position: relative;

            img {
                width: 100%;
                object-fit: cover;
            }

            .header_content {
                width: 1200px;
                height: 100%;
                box-sizing: border-box;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                text-align: right;
                line-height: 100%;
                vertical-align: middle;
                top: 0;

                button {
                    font-size: 20px;
                    color: #FFFFFF;
                    text-align: center;
                    top: 50%;
                    position: relative;
                    transform: translateY(-50%);
                    background-color: transparent;
                }
            }
        }

        .body {
            width: 1200px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 68px;
            min-height: calc(100% - 150px - 90px - 68px);

            .pager {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
            }

            .paper_container {
                height: 100%;
                display: flex;
                box-sizing: border-box;
                flex-wrap: wrap;

                .paper_item {
                    width: 277px;
                    height: 181px;
                    cursor: pointer;
                    border: 2px solid rgba(225, 176, 92, 1);
                    margin-bottom: 50px;
                    margin-right: 25px;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    &:nth-child(4n) {
                        margin-right: 0;
                    }

                    .item_inner_box {
                        width: 267px;
                        height: 172px;
                        position: absolute;
                        border: 2px solid rgba(225, 176, 92, 1);
                        transition: box-shadow .2s linear;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);

                        &:hover {
                            box-shadow: 4px 5px 9px 4px rgba(0, 0, 0, 0.09);
                        }

                        img {
                            max-width: 100%;
                            position: relative;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
        }

        .footer {
            font-size: 16px;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            text-align: center;
            margin-top: 30px;
            margin-bottom: 30px;

            &.mobile {
                display: none;
            }
        }
    }
}

@media screen and(min-width:769px) and (max-width: 1200px) {
    .homePage {
        width: 100%;
        height: 100%;
        position: relative;
        overflow-y: auto;
        box-sizing: border-box;
        background: url("../../../public/image/bgc_pad.png") no-repeat;

        .container {
            width: 100%;
            height: 100%;
        }

        .header {
            width: 100%;

            img {
                width: 100%;
                object-fit: cover;
            }

            .header_content {
                display: none;
            }
        }

        .body {
            padding: 65px 105px 0;
            box-sizing: border-box;
            margin: 0 auto;

            .pager {
                text-align: center;
            }

            .paper_container {
                height: 100%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;

                .paper_item {
                    width: 45%;
                    height: 173px;
                    border: 2px solid rgba(225, 176, 92, 1);
                    margin-bottom: 26px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .item_inner_box {
                        width: calc(100% - 4px);
                        height: calc(100% - 4px);
                        border: 1px solid rgba(225, 176, 92, 1);
                        transition: box-shadow .2s linear;
                        padding: 0 10px;
                        box-sizing: border-box;

                        &:hover {
                            box-shadow: 4px 5px 9px 4px rgba(0, 0, 0, 0.09);
                        }

                        img {
                            max-width: 100%;
                            position: relative;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
        }

        .footer {
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            color: #5B5C64;
            text-align: center;
            margin-top: 30px;
            margin-bottom: 30px;
            bottom: 0;

            &.pc {
                display: none;
            }
        }
    }
}

@media screen and(max-width:768px) {
    .homePage {
        width: 100%;
        height: 100%;
        position: relative;
        overflow-y: auto;
        box-sizing: border-box;
        background: url("../../../public/image/bgc_mobile.png") no-repeat;



        .container {
            width: 100%;
            height: 100%;
        }

        .header {
            width: 100%;

            img {
                width: 100%;
                object-fit: cover;
            }

            .header_content {
                display: none;
            }
        }

        .body {
            padding: 25px 35px 0;
            box-sizing: border-box;
            margin: 0 auto;
            min-height: calc(100% - 125px);

            .pager {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                display: none;
            }

            .paper_container {
                height: 100%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;

                .paper_item {
                    width: 45%;
                    height: 89px;
                    border: 2px solid rgba(225, 176, 92, 1);
                    margin-bottom: 26px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .item_inner_box {
                        width: calc(100% - 4px);
                        height: calc(100% - 4px);
                        border: 1px solid rgba(225, 176, 92, 1);
                        transition: box-shadow .2s linear;
                        padding: 0 10px;
                        box-sizing: border-box;

                        &:hover {
                            box-shadow: 4px 5px 9px 4px rgba(0, 0, 0, 0.09);
                        }

                        img {
                            max-width: 100%;
                            position: relative;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
        }

        .footer {
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            color: #5B5C64;
            text-align: center;
            margin-top: 30px;
            margin-bottom: 30px;
            bottom: 0;

            &.pc {
                display: none;
            }
        }
    }
}
</style>